import { useConsentForms } from '@hook'
import { ADMIN_MODAL_TYPE, useModalStore } from '@modal'
import { ModalHeader } from '@ui'
import { Box, Layer, Spinner, Text } from 'grommet'
import parse from 'html-react-parser' // Import the library
import { useLocation, useParams } from 'react-router-dom'

type Props = {
  onClose: () => void
  id?: string
  doc_temp_id?: string
  defaultData?: {
    id: string
    title: string
    is_signed: boolean
    isUpdate?: boolean
    consent_form_id?: string
    patient_id: string
  }
}
const Template = ({ onClose, id, doc_temp_id, defaultData }: Props) => {
  const { openModal } = useModalStore()
  const { patientId } = useParams<string>()

  const { pathname } = useLocation()
  const isIntakeConsent = pathname.includes('intake')
  const { singleConsentFormData, previewConsentForm, previewConsentFormIsLoading, singleConsentFormIsLoading } =
    useConsentForms({
      document_template_id: isIntakeConsent ? defaultData?.id : doc_temp_id,
      patient_id: patientId || defaultData?.patient_id,
      id: isIntakeConsent ? undefined : id
    })

  return (
    <Box>
      <Layer
        margin={{ vertical: '8px' }}
        modal
        onClickOutside={onClose}
        onEsc={onClose}
        position="center"
        style={{ borderRadius: '15px', borderColor: '#999999 !important' }}
      >
        <div
          className="flex flex-col flex-1 overflow-auto"
          style={{ width: '81vw', maxHeight: '90vh', borderRadius: '2em', paddingBottom: '20px' }}
        >
          <ModalHeader
            onClose={onClose}
            title={
              previewConsentForm?.title || singleConsentFormData?.attributes?.title || 'Medical Procedure Consent Form'
            }
          />
          {(previewConsentFormIsLoading || singleConsentFormIsLoading) && (
            <Box align="center" justify="center" pad="medium">
              <Spinner size="medium" />
              <Text>Loading notes...</Text>
            </Box>
          )}
          <div className="overflow-auto">
            <div
              className="mx-6 px-8 py-4 border border-t-0 rounded-md rounded-t-none border-solid border-[#999999] "
              onClick={() =>
                (!singleConsentFormData?.attributes?.is_signed || defaultData?.is_signed === false) &&
                openModal(ADMIN_MODAL_TYPE.PROCEDURE_APPROVAL, {
                  id: isIntakeConsent ? defaultData?.id : doc_temp_id,
                  isUpdate: !isIntakeConsent ? !!singleConsentFormData?.attributes.updated_at : defaultData?.isUpdate,
                  consent_form_id: !isIntakeConsent ? singleConsentFormData?.id : defaultData?.consent_form_id
                })
              }
            >
              {previewConsentForm?.content || singleConsentFormData?.attributes?.content
                ? parse((previewConsentForm?.content ?? singleConsentFormData?.attributes?.content) || '')
                : null}
            </div>
          </div>
        </div>
      </Layer>
    </Box>
  )
}

export default Template
